import { VStack } from "goi_common";
import { useRouter } from "next/router";
import React, { useMemo } from "react";

import { useDisclosure } from "@chakra-ui/react";

import { Header } from "./Header";
import Menu from "./Menu";
import TossHeader from "./TossHeader";
import { DevWarningBanner } from "goi_common";
import { FomoBanner } from "@/components/Fomo/FomoBanner";

import { useFunnelData } from "@/utils/getFunnelRouteDetail";

interface LayoutProps {
  children: React.ReactNode;
  showConditional?: boolean;
}

export default function Layout({ children, showConditional }: LayoutProps) {
  const router = useRouter();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { funnelKey } = useFunnelData();

  const isRouteIncludeToss =
    router.route.includes("toss") || funnelKey === "GROUP_toss_100";

  const isHeaderHidden = useMemo(() => {
    if (showConditional) {
      return false;
    }
    return (
      router.route === "/login" ||
      // 온보딩은 계약서 하위지만 GNB 를 노출한다 (결제 후 온보딩과 동일 화면)
      (router.route.includes("contract-check/") &&
        router.route !== "/contract-check/onboarding") ||
      router.route.includes("contract-confirm") ||
      router.route === "/register-pay-method" ||
      router.route === "/register-pay-method/select-method" ||
      router.route === "/register-pay-method/failure" ||
      (router.route.includes("/event") &&
        !router.route.includes("/promotion/event")) ||
      router.route.includes("closed") ||
      router.route === "/content/feeds/sangjo" ||
      router.route === "/content/feeds/ceo-youtube" ||
      router.route.includes("review/") ||
      router.route.includes("content/feeds/tip") ||
      router.route === "/content/feeds/youtube/luckyquiz" ||
      router.route === "/content/feeds/youtube/luckyquiz/[quizId]" ||
      (router.route.includes("/call-lead") &&
        router.route !== "/call-lead/leadform") ||
      (router.route.includes("content") &&
        router.route !== "/content" &&
        router.route !== "/registration/reminder/content") ||
      router.route.includes("refund") ||
      router.asPath.includes("/promotion/event/26-gas") ||
      router.route.includes("/promotion/oxquiz") ||
      router.route.includes("/registration/confirmation-contract/oxquiz") ||
      router.route === "/registration/reminder" ||
      router.route === "/registration/reminder/share" ||
      router.route === "/family-share" ||
      router.route === "/retention" ||
      router.route.includes("/referral") ||
      router.route === "/introduce/new/hsp" ||
      // 미가입자 안내·본인확인은 혜택 하위지만 GNB 를 노출한다 (Figma GNB/Platform)
      (router.route.includes("/prime-benefit") &&
        router.route !== "/prime-benefit/not-subscribed" &&
        router.route !== "/prime-benefit/verify") ||
      router.route.startsWith("/redirect/") ||
      isRouteIncludeToss
    );
  }, [router, showConditional, isRouteIncludeToss]);

  return (
    <>
      {!(process.env.NEXT_PUBLIC_IS_PRODUCTION === "true") && (
        <DevWarningBanner />
      )}
      {!isHeaderHidden && <Header onOpen={onOpen} />}
      <FomoBanner />
      {isRouteIncludeToss &&
        !router.route.includes("registration/toss-payment") && (
          <TossHeader onOpen={onOpen} />
        )}
      <VStack
        css={
          isHeaderHidden && {
            marginTop: 0,
          }
        }
      >
        {children}
      </VStack>
      <Menu isOpen={isOpen} onClose={onClose} />
    </>
  );
}
